import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from '../../helpers/WithRouter';
import NotFound from '../../containers/NotFound/NotFound';
import DataLoader from '../../components/DataLoader/DataLoader';
import DataError from '../../components/DataError/DataError';
import Header from '../../components/Header/Header';
import BannerCarousel from '../../components/BannerCarousel/BannerCarousel';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import CategoriesOptionsV2 from '../../components/CategoriesOptionsV2/CategoriesOptionsV2';
import ProductBox from '../../components/ProductBox/ProductBox';
import FiltersOptions from '../../components/FiltersOptions/FiltersOptions';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import Paginator from '../../components/Paginator/Paginator';
import Question from '../../components/Question/Question';
import FiltersModal from '../../components/FiltersModal/FiltersModal';
import ComparePreview from '../../components/ComparePreview/ComparePreview';
import ComparisonModal from '../../components/ComparisonModal/ComparisonModal';
import Button from '../../components/Button/Button';
import ImageWrapper from '../../components/ImageWrapper/ImageWrapper';
import BannerExternalUrlModal from '../../components/BannerExternalUrlModal/BannerExternalUrlModal';
import Navigation from '../../config/Navigation';
import FeaturedProductMetric from '../../helpers/FeaturedProductMetric';
import Storage from '../../helpers/Storage';
import Debug from '../../helpers/Debug';
import Activity from "../../helpers/Activity";
import Viewport from '../../helpers/Viewport';
import HTMLElement from '../../helpers/HTMLElement';
import Text from '../../helpers/Text';
import {QuickFilter as _QuickFilter} from '../../models/QuickFilter';
import {Filter as _Filter} from '../../models/Filter';
import {Product as _Product} from '../../models/Product';
import {Category as _Category} from '../../models/Category';
import {Catalog as _Catalog} from '../../models/Catalog';
import {Banner as _Banner, bannerConverter} from '../../models/Banner';
import {categoryConverter} from '../../models/Category';
import {productConverter} from '../../models/Product';
import {PLP_ITEMS_PER_PAGE} from "../../config/App";
import CatalogSearch from '../../helpers/CatalogSearch';
import {firestore, getCollectionPath} from '../../config/Firebase';
import {collection, doc, onSnapshot, query, where} from 'firebase/firestore';
import closeIcon from './images/close.png';
import './Category.css';

class Category extends React.Component {
    constructor(props) {
        super(props);
        const parameters = new URLSearchParams(this.props.location.search);
        const categoryId = this.props.customHomeCategoryId ? this.props.customHomeCategoryId : this.props.params.categoryId;
        const categories = parameters.getAll('categories');
        const brands = parameters.getAll('brands');
        const searchQuery = this.props.params.searchQuery;
        if (categories && categories.length > 0) {
            const storageCategories = {category: categoryId, categoryFilters: categories};
            Storage.setCategoryFilters(storageCategories);
        }
        if (brands && brands.length > 0) {
            const storageFilters = {type: searchQuery ? 'search' : 'category', key: searchQuery ? searchQuery : categoryId, filters: [{id: 'brands-filter', options: brands.map((brand) => ({id: Text.toHash(brand), value: true}))}]};
            Storage.setFilters(storageFilters);
        }
        const isSearching = !!searchQuery;
        const mainOptions = [
            {label: 'Modelo 3D', value: '3d'},
            {label: 'Destacados', value: 'featured'},
            {label: 'Menor precio', value: 'lowest-price'},
            {label: 'Mayor precio', value: 'highest-price'}
        ];
        let sortOptions = [];
        if (isSearching) sortOptions.push({label: 'Relevancia', value: 'relevance'});
        sortOptions = sortOptions.concat(mainOptions);
        let sorting = this.getSorting(categoryId, searchQuery);
        sorting = !sorting && searchQuery ? 'relevance' : sorting;
        let match = sorting ? sortOptions.find(option => option.value === sorting) : undefined;
        this.state = {
            searchQuery: searchQuery,
            queryId: undefined,
            categoryId: categoryId,
            isLoadingCategory: true,
            categoryLoaded: false,
            category: undefined,
            isLoadingBanners: true,
            bannersLoaded: false,
            banners: [],
            isLoadingChildren: true,
            childrenLoaded: false,
            children: [],
            isLoadingProducts: true,
            productsLoaded: false,
            products: [],
            quickFilters: [],
            filters: [],
            answeredQuestions: [],
            showFilters: false,
            compareMode: false,
            comparisonList: [],
            comparisonMaxItems: 3,
            showComparison: false,
            notFound: false,
            errorMessage: undefined,
            errorActionLabel: undefined,
            errorAction: undefined,
            selectedCategories: [],
            sortBy: match ? match.value : 'featured',
            sortOptions: sortOptions,
            page: 1,
            perPage: PLP_ITEMS_PER_PAGE,
            lastProduct: undefined,
            lastProductIndicatorDuration: 8,
            scrolledToLastProduct: false,
            enableStickyBar: false,
            results: [],
            productsBoxesMap: {},
            showBannerExternalUrlModal: false,
            bannerModalExternalUrl: undefined
        };
        this._isMounted = true;
        this._featuredMetricsInterval = undefined;
        this._unsubscribeCategory = undefined;
        this._unsubscribeBanners = undefined;
        this._unsubscribeChildren = undefined;
        this._unsubscribeProducts = undefined;
        this._categoryViewContentWrapperRef = React.createRef();
        this._lastScroll = 0;
    };

    getMetadata = () => {
        const {queryId} = this.state;
        const metadata = this.props.getMetadata();
        metadata.queryId = queryId;
        return metadata;
    };

    changeState = (newState, callback) => {
        if (this._isMounted) {
            this.setState(newState, () => {
                if (callback) callback();
            });
        }
    };

    componentDidMount() {
        this._isMounted = true;
        this.setResizeListener();
        this.setScrollListener();
        this.startFeaturedMetricsInterval();
        if (this.state.searchQuery) {
            this.disableBanners();
            this.getSearchProducts();
        } else {
            this.getBanners();
            this.getCategory();
            this.getCategoryChildren();
            this.getCategoryProducts();
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const needsReload = _Catalog.catalogChanged(prevProps.catalog, this.props.catalog);
        if (needsReload) Navigation.reload();
        let oldStyle = prevProps.style;
        let newStyle = this.props.style;
        const oldQuickFilterExclusivePriceLabel = oldStyle && oldStyle['category'] ? oldStyle['category']['quickFilterExclusivePriceLabel'] : undefined;
        const oldShowExternalSale = oldStyle && oldStyle['global'] && oldStyle['global']['filters'] && oldStyle['global']['filters']['showExternalSale'] ? oldStyle['global']['filters']['showExternalSale'] : false;
        const oldExternalSaleLabel = oldStyle && oldStyle['global'] && oldStyle['global']['filters'] && oldStyle['global']['filters']['externalSaleLabel'] ? oldStyle['global']['filters']['externalSaleLabel'] : false;
        const oldClientName = oldStyle && oldStyle['global'] && oldStyle['global']['clientName'] ? oldStyle['global']['clientName'] : undefined;
        const newQuickFilterExclusivePriceLabel = newStyle && newStyle['category'] ? newStyle['category']['quickFilterExclusivePriceLabel'] : undefined;
        const newShowExternalSale = newStyle && newStyle['global'] && newStyle['global']['filters'] && newStyle['global']['filters']['showExternalSale'] ? newStyle['global']['filters']['showExternalSale'] : false;
        const newExternalSaleLabel = newStyle && newStyle['global'] && newStyle['global']['filters'] && newStyle['global']['filters']['externalSaleLabel'] ? newStyle['global']['filters']['externalSaleLabel'] : false;
        const newClientName = newStyle && newStyle['global'] && newStyle['global']['clientName'] ? newStyle['global']['clientName'] : undefined;
        const quickFilterExclusivePriceLabelChanged = oldQuickFilterExclusivePriceLabel !== newQuickFilterExclusivePriceLabel;
        const showExternalSaleChanged = oldShowExternalSale !== newShowExternalSale;
        const externalSaleLabelChanged = oldExternalSaleLabel !== newExternalSaleLabel;
        const clientNameChanged = oldClientName !== newClientName;
        if (quickFilterExclusivePriceLabelChanged) this.getQuickFilters();
        if (showExternalSaleChanged || externalSaleLabelChanged || clientNameChanged) {
            this.getFilters(false);
            if (showExternalSaleChanged) {
                setTimeout(() => {
                    this.updateResults();
                });
            }
        }

        // Check if any featured products are in viewport
        const oldMap = prevState.productsBoxesMap;
        const newMap = this.state.productsBoxesMap;
        this.sendFeaturedProductsMetrics(oldMap, newMap);
    };

    componentWillUnmount() {
        this._isMounted = false;
        this.unsubscribe();
        this.removeResizeListener();
        this.removeScrollListener();
        this.stopFeaturedMetricsInterval();
    };

    setResizeListener = () => {
        window.addEventListener('resize', this.handleResize);
    };

    removeResizeListener = () => {
        window.removeEventListener('resize', this.handleResize);
    };

    handleResize = () => {
        this.checkForStickyBar();
    };

    setScrollListener = () => {
        const view = document.getElementsByClassName('view')[0];
        view.addEventListener('scroll', this.handleScroll);
    };

    removeScrollListener = () => {
        const view = document.getElementsByClassName('view')[0];
        view.removeEventListener('scroll', this.handleScroll);
    };

    handleScroll = (event) => {
        const currentScroll = event.target.scrollTop;
        const difference = currentScroll - this._lastScroll;
        let direction;
        if (difference === 0) direction = 'none';
        else if (difference > 0) direction = 'down';
        else if (difference < 0) direction = 'up';
        this._lastScroll = currentScroll;
        this.checkForStickyBar(direction);
        this.checkForFeaturedProductsInViewport();
    };

    startFeaturedMetricsInterval = () => {
        this._featuredMetricsInterval = setInterval(() => {
            this.checkForFeaturedProductsInViewport();
        }, 1000);
    };

    stopFeaturedMetricsInterval = () => {
        if (this._featuredMetricsInterval) clearInterval(this._featuredMetricsInterval);
    };

    checkForFeaturedProductsInViewport = () => {
        const oldMap = {...this.state.productsBoxesMap};
        const newMap = {};
        document.querySelectorAll('.product-box.featured').forEach((element) => {
            const newInViewport = HTMLElement.isElementInViewport(element);
            const id = element.dataset.id;
            if (id) newMap[id] = newInViewport;
        });
        let anyDifference = false;
        Object.keys(oldMap).forEach((key) => {
            if (oldMap[key] !== newMap[key]) anyDifference = true;
        });
        Object.keys(newMap).forEach((key) => {
            if (oldMap[key] !== newMap[key]) anyDifference = true;
        });
        if (anyDifference) {
            this.setState({productsBoxesMap: newMap});
        }
    };

    isFeaturedProductInViewport = (productId) => {
        const {productsBoxesMap} = this.state;
        return productsBoxesMap && productsBoxesMap[productId];
    };

    sendFeaturedProductsMetrics = (oldMap, newMap) => {
        const newKeys = Object.keys(newMap);
        let changes = [];
        if (newKeys.length > 0) {
            newKeys.forEach((newKey) => {
                const oldValue = oldMap[newKey];
                const newValue = newMap[newKey];
                if (oldValue !== newValue && newValue) changes.push(newKey);
            });
        }
        if (changes.length > 0) {
            const {category, products} = this.state;
            const metadata = this.getMetadata();
            const client = metadata ? metadata.client : undefined;
            const instance = metadata ? metadata.instance : undefined;
            changes.forEach((id) => {
                const product = products.find((p) => p.id === id);
                if (client && instance && product) {
                    const mediaType = product.featuredData && product.featuredData.mediaType ? product.featuredData.mediaType : 'default';
                    FeaturedProductMetric.incrementViewCount(product.id, category.id, mediaType, client, instance);
                }
            });
        }
    };

    checkForStickyBar = (scrollDirection) => {
        let enableStickyBar = false;
        if (!this.props.accessibilityMode && scrollDirection === 'up') {
            const viewport = Viewport.dimensions;
            const view = document.getElementsByClassName('view')[0];
            if (!view) enableStickyBar = false;
            else enableStickyBar = viewport.height >= 1500 && viewport.width >= 600 ? view.scrollTop > 300 : false;
        }
        if (enableStickyBar !== this.state.enableStickyBar) this.changeState({enableStickyBar: enableStickyBar});
    };

    getSearchProducts = () => {
        const {searchQuery} = this.state;
        let searchSorting = [];
        let products = [];
        let errorMessage = undefined;
        let errorActionLabel = undefined;
        let errorAction = undefined;
        CatalogSearch.search(this.props.client, this.props.catalog, searchQuery, undefined)
            .then((results) => {
                if (results.length === 0) {
                    errorMessage = 'No se han encontrado productos con el criterio de búsqueda especificado';
                    errorActionLabel = 'Ir al inicio';
                    errorAction = this.home;
                    throw new Error('No results');
                } else {
                    results.forEach((product) => {
                        searchSorting.push(product.id);
                        products.push(product);
                    });
                }
            })
            .then(() => {
                const category = new _Category({id: 'search', name: `Buscando: ${searchQuery}`});
                this.changeState({
                    searchSorting: searchSorting,
                    isLoadingCategory: false,
                    categoryLoaded: true,
                    category: category,
                    isLoadingChildren: false,
                    childrenLoaded: true,
                    children: [],
                    isLoadingProducts: false,
                    productsLoaded: true,
                    products: products,
                }, () => {
                    Storage.removeCategoryFilters();
                    this.getQuickFilters();
                    this.getFilters(false);
                    this.getAnsweredQuestions();
                    this.getComparison();
                    this.getPage();
                    this.getLastProduct();
                    this.saveSelectedSorting();
                    setTimeout(() => {
                        this.updateResults();
                    });
                });
            })
            .catch((error) => {
                Debug.printToLog('error', error);
                this.onLoadError(
                    false,
                    errorMessage || 'Se ha producido un error al realizar la búsqueda',
                    errorActionLabel || 'Reintentar',
                    errorAction || Navigation.reload
                );
            });
    };

    getCategory = () => {
        const _path = getCollectionPath(this.props.client, 'categories');
        const _doc = doc(firestore, _path, this.state.categoryId).withConverter(categoryConverter);
        this._unsubscribeCategory = onSnapshot(_doc, (_document) => {
            if (_document.exists()) {
                const category = _document.data();
                const parents = category.parents || [];
                parents.push(category.id);
                if (category.isEmpty) this.onLoadError(false, 'No se han encontrado productos en esta categoría', 'Volver', this.back);
                else if (!category.isVisible) this.onLoadError(true, undefined, 'Volver', this.back);
                else if (!_Catalog.inCatalog(this.props.catalog, parents)) this.onLoadError(true, undefined, 'Volver', this.back);
                else this.changeState({isLoadingCategory: false, categoryLoaded: true, category: category});
            } else this.onLoadError(true, undefined, 'Volver', this.back);
        }, (error) => {
            Debug.printToLog('error', error);
            this.onLoadError(false, 'Se ha producido un error al cargar la categoría', 'Reintentar', Navigation.reload);
        });
    };

    getBanners = () => {
        const _path = getCollectionPath(this.props.client, 'banners');
        const _collection = collection(firestore, _path);
        const _where = where('categories', 'array-contains', this.state.categoryId);
        const _query = query(_collection, _where).withConverter(bannerConverter);
        this._unsubscribeBanners = onSnapshot(_query, (_snapshot) => {
            let {banners} = this.state;
            _snapshot.docChanges().forEach((change) => {
                const id = change.doc.id;
                const data = change.doc.data();
                if (change.type === 'added') {
                    banners.push(data);
                } else if (change.type === 'modified') {
                    const index = banners.findIndex(banner => banner.id === id);
                    if (index >= 0) banners[index] = data;
                } else if (change.type === 'removed') {
                    const index = banners.findIndex(banner => banner.id === id);
                    if (index >= 0) banners.splice(index, 1);
                }
            });
            this.changeState({isLoadingBanners: false, bannersLoaded: true, banners: banners});
        }, (error) => {
            Debug.printToLog('error', error);
            this.changeState({isLoadingBanners: false, bannersLoaded: false, banners: []});
        });
    };

    disableBanners = () => {
        this.changeState({isLoadingBanners: false, bannersLoaded: true, banners: []});
    };

    getCategoryChildren = () => {
        const _path = getCollectionPath(this.props.client, 'categories');
        const _collection = collection(firestore, _path);
        const _where1 = where('parents', 'array-contains', this.state.categoryId);
        const _where2 = where('is_empty', '==', false);
        const _where3 = where('is_visible', '==', true);
        const _query = query(_collection, _where1, _where2, _where3).withConverter(categoryConverter);
        this._unsubscribeChildren = onSnapshot(_query, (_snapshot) => {
            let {children} = this.state;
            _snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                    children.push(change.doc.data());
                } else if (change.type === 'modified') {
                    const index = children.findIndex(child => child.id === change.doc.id);
                    if (index >= 0) children[index] = change.doc.data();
                } else if (change.type === 'removed') {
                    const index = children.findIndex(child => child.id === change.doc.id);
                    if (index >= 0) children.splice(index, 1);
                }
            });
            this.changeState({isLoadingChildren: false, childrenLoaded: true, children: children}, () => {
                this.getCategoryFilters(false);
            });
        }, (error) => {
            Debug.printToLog('error', error);
            this.onLoadError(false, 'Se ha producido un error al cargar las subcategorías disponibles', 'Reintentar', Navigation.reload);
        });
    };

    getCategoryProducts = () => {
        const _path = getCollectionPath(this.props.client, 'items');
        const _collection = collection(firestore, _path);
        const _where1 = where('categories', 'array-contains', this.state.categoryId);
        const _query = query(_collection, _where1).withConverter(productConverter);
        this._unsubscribeProducts = onSnapshot(_query, (_snapshot) => {
            let {products} = this.state;
            _snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                    products.push(change.doc.data());
                } else if (change.type === 'modified') {
                    const index = products.findIndex(product => product.id === change.doc.id);
                    if (index >= 0) products[index] = change.doc.data();
                } else if (change.type === 'removed') {
                    const index = products.findIndex(product => product.id === change.doc.id);
                    if (index >= 0) products.splice(index, 1);
                }
            });
            this.changeState({isLoadingProducts: false, productsLoaded: true, products: products}, () => {
                this.getQuickFilters();
                this.getFilters(false);
                this.getAnsweredQuestions();
                this.getComparison();
                this.getPage();
                this.getLastProduct();
                this.saveSelectedSorting();
                setTimeout(() => {
                    this.updateResults();
                });
            });
        }, (error) => {
            Debug.printToLog('error', error);
            this.onLoadError(false, 'Se ha producido un error al obtener los productos de la categoría.', 'Reintentar', Navigation.reload);
        });
    };

    getCategoryFilters = (triggerUpdate) => {
        const {categoryId, children} = this.state;
        const data = Storage.getCategoryFilters();
        let validCategoryFilters = [];
        if (data && data.category === categoryId) {
            data.categoryFilters.forEach((categoryFilter) => {
                const match = children.find(child => child.id === categoryFilter);
                if (match) validCategoryFilters.push(categoryFilter);
            });
        } else Storage.removeCategoryFilters();
        this.changeState({selectedCategories: validCategoryFilters}, triggerUpdate ? this.updateResults : () => {});
    };

    getQuickFilters = () => {
        const {style} = this.props;
        const {categoryId, searchQuery} = this.state;
        const quickFilterExclusivePriceLabel = style && style['category'] ? style['category']['quickFilterExclusivePriceLabel'] : undefined;
        let quickFilters = this.buildQuickFilters(quickFilterExclusivePriceLabel);
        quickFilters = _QuickFilter.fromStorage(categoryId, searchQuery, quickFilters);
        this.changeState({quickFilters: quickFilters});
    };

    getFilters = (triggerUpdate) => {
        const {style} = this.props;
        const {categoryId, searchQuery, products} = this.state;
        const showExternalSale = style && style['global'] && style['global']['filters'] && style['global']['filters']['showExternalSale'] ? style['global']['filters']['showExternalSale'] : false;
        const externalSaleLabel = style && style['global'] && style['global']['filters'] && style['global']['filters']['externalSaleLabel'] ? style['global']['filters']['externalSaleLabel'] : false;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const showAIGeneratedFeatures = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedFeatures'] ? style['global']['features']['showAIGeneratedFeatures'] : false;
        let validProducts = _Product.filterValidProducts(products);
        let filters = _Filter.buildFilters(validProducts, showExternalSale, externalSaleLabel, clientName, showAIGeneratedFeatures);
        filters = _Filter.fromStorage(categoryId, searchQuery, filters);
        this.changeState({filters: filters}, triggerUpdate ? this.updateResults : () => {});
    };

    getAnsweredQuestions = () => {
        const {categoryId, searchQuery} = this.state;
        const storageData = Storage.getAnsweredQuestions();
        const storageType = storageData ? storageData['type'] : undefined;
        const storageKey = storageData ? storageData['key'] : undefined;
        const storageAnsweredQuestions = storageData ? storageData['answeredQuestions'] : undefined;
        let isCategory = storageType === 'category' && categoryId && storageKey === categoryId;
        let isSearch = storageType === 'search' && !categoryId && storageKey === searchQuery;
        if (isCategory || isSearch) this.changeState({answeredQuestions: storageAnsweredQuestions});
        else Storage.removeAnsweredQuestions();
    };

    getComparison = () => {
        const {categoryId, searchQuery, products} = this.state;
        const data = Storage.getComparison();
        if (!data) {
            Storage.removeComparison();
            return;
        }
        const sameCategory = data.type === 'category' && categoryId && data.key === categoryId;
        const sameSearch = data.type === 'search' && !categoryId && data.key === searchQuery;
        if (!sameCategory && !sameSearch) {
            Storage.removeComparison();
            return;
        }
        let validComparisonList = [];
        data.products.forEach((comparisonProductId) => {
            const match = products.find(product => product.id === comparisonProductId);
            if (match) validComparisonList.push(match);
        });
        this.changeState({comparisonList: validComparisonList});
    };

    getSorting = (categoryId, searchQuery) => {
        const storageData = Storage.getSorting();
        const storageType = storageData ? storageData['type'] : undefined;
        const storageKey = storageData ? storageData['key'] : undefined;
        const storageSortBy = storageData ? storageData['sortBy'] : undefined;
        let isCategory = storageType === 'category' && categoryId && storageKey === categoryId;
        let isSearch = storageType === 'search' && !categoryId && storageKey === searchQuery;
        if (isCategory || isSearch) return storageSortBy;
        else return undefined;
    };

    getPage = () => {
        const {categoryId, searchQuery} = this.state;
        const data = Storage.getPage();
        let reset = false;
        if (data) {
            if (data.type === 'category' && categoryId && data.key === categoryId) {
                this.changeState({page: data.page});
            } else if (data.type === 'search' && !categoryId && data.key === searchQuery) {
                this.changeState({page: data.page});
            } else reset = true;
        } else reset = true;
        if (reset) this.changeState({page: 1}, this.saveSelectedPage);
    }

    getLastProduct = () => {
        const {categoryId, searchQuery, lastProductIndicatorDuration, scrolledToLastProduct} = this.state;
        const data = Storage.getPage();
        if (data) {
            const sameCategory = data.type === 'category' && categoryId && data.key === categoryId;
            const sameSearch = data.type === 'search' && !categoryId && data.key === searchQuery;
            const shouldScroll = (sameCategory || sameSearch) && !scrolledToLastProduct;
            if (shouldScroll) {
                setTimeout(() => {
                    const lastProduct = Storage.getLastProduct();
                    const element = document.getElementById(lastProduct);
                    const inViewport = HTMLElement.isElementInViewport(element);
                    if (element && !inViewport) element.scrollIntoView({behavior: 'smooth', block: 'center'});
                    this.changeState({lastProduct: lastProduct, scrolledToLastProduct: true}, () => {
                        setTimeout(() => {this.changeState({lastProduct: undefined})}, lastProductIndicatorDuration * 1000);
                    });
                }, 1000);
            } else Storage.removeLastProduct();
        }
    };

    getValidChildren = () => {
        const {children, products} = this.state;
        const validProducts = _Product.filterValidProducts(products);
        let validChildren = [];
        if (children && children.length && validProducts && validProducts.length > 0) {
            children.forEach((child) => {
                const match = validProducts.find((product) => product.categories.includes(child.id));
                if (match) validChildren.push(child);
            });
            if (validChildren.length > 1) return validChildren;
            else return [];
        } else return validChildren;
    };

    showChildren = () => {
        const validChildren = this.getValidChildren();
        return validChildren && validChildren.length > 0;
    };

    applyBannerFilters = (bannerUrl) => { // Filter type can only be category because this function is only called from a category type banner.
        const urlObject = new URL(bannerUrl, window.location.origin);
        const parameters = new URLSearchParams(urlObject.search);
        const pathname = urlObject.pathname;
        const split = pathname.split('/');
        const bannerCategoryId = split[0] !== pathname ? split[split.length - 1] : undefined;
        if (this.state.categoryId !== bannerCategoryId) return;
        const categories = parameters.getAll('categories');
        const validChildren = this.getValidChildren();
        const validCategories = categories.filter((category) => !!validChildren.find((child) => child.id === category));
        if (validCategories && validCategories.length > 0) {
            const storageCategories = {category: this.state.categoryId, categoryFilters: validCategories};
            Storage.setCategoryFilters(storageCategories);
        } else Storage.removeCategoryFilters();
        this.getCategoryFilters(true);
        const brands = parameters.getAll('brands');
        const brandsFilter = this.state.filters ? this.state.filters.find((filter) => filter.id === 'brands-filter') : undefined;
        const availableBrands = brandsFilter ? brandsFilter.options.map((option) => option.label) : [];
        const validBrands = brands.filter((brand) => availableBrands.includes(brand));
        if (validBrands && validBrands.length > 0) {
            const type = 'category';
            const key = this.state.categoryId;
            const storageFilters = {type: type, key: key, filters: [{id: 'brands-filter', options: validBrands.map((brand) => ({id: Text.toHash(brand), value: true}))}]};
            Storage.setFilters(storageFilters);
        } else Storage.removeFilters();
        this.getFilters(true);
    };

    unsubscribe = () => {
        if (this._unsubscribeCategory) this._unsubscribeCategory();
        if (this._unsubscribeBanners) this._unsubscribeBanners();
        if (this._unsubscribeChildren) this._unsubscribeChildren();
        if (this._unsubscribeProducts) this._unsubscribeProducts();
    };

    hasBanners = () => {
        const {customHomeCategoryId} = this.props;
        const {banners} = this.state;
        return !!customHomeCategoryId && banners && banners.length > 0;
    };

    loadingData = () => {
        return this.state.isLoadingCategory || this.state.isLoadingBanners || this.state.isLoadingChildren || this.state.isLoadingProducts;
    };

    dataLoaded = () => {
        return this.state.categoryLoaded && this.state.bannersLoaded && this.state.childrenLoaded && this.state.productsLoaded;
    };

    onLoadError = (notFound, message, actionLabel, action) => {
        this.changeState({
            isLoadingCategory: false,
            categoryLoaded: false,
            category: undefined,
            isLoadingChildren: false,
            childrenLoaded: false,
            children: [],
            isLoadingProducts: false,
            productsLoaded: false,
            products: [],
            filters: [],
            notFound: notFound,
            errorMessage: message,
            errorActionLabel: actionLabel,
            errorAction: action
        });
    };

    home = () => {
        const url = Navigation.getHomeUrl();
        this.props.navigate(url);
    };

    back = () => {
        this.props.navigate(-1);
    };

    openBannerExternalUrl = (url) => {
        this.changeState({showBannerExternalUrlModal: true, bannerModalExternalUrl: url});
    };

    closeBannerExternalUrl = () => {
        this.changeState({showBannerExternalUrlModal: false, bannerModalExternalUrl: undefined});
    };

    scrollToElement = (target) => {
        const {children} = this.state;
        let elementId = target;
        const match = children.find(child => child.id === target);
        if (match) match.focus = true;
        this.changeState({children: children});
        const element = document.getElementById(elementId);
        if (element) element.scrollIntoView({behavior: 'smooth'});
    };

    buildQuickFilters(exclusivePriceLabel) {
        const {products} = this.state;
        const validProducts = _Product.filterValidProducts(products);
        const anyExclusivePrices = _Product.filterByExclusivePrice(validProducts).length > 0;
        const anyDiscounts = _Product.filterByDiscounts(validProducts).length > 0;
        const anyFreeDelivery = _Product.filterByFreeDelivery(validProducts).length > 0;
        const anyPickup = _Product.filterByPickup(validProducts).length > 0;
        const filters = [];
        if (anyExclusivePrices) filters.push(new _QuickFilter({id: 'exclusive-price', label: exclusivePriceLabel || 'Precio exclusivo', selected: false, action: _Product.filterByExclusivePrice}))
        if (anyDiscounts)       filters.push(new _QuickFilter({id: 'discounts', label: 'Descuentos', selected: false, action: _Product.filterByDiscounts}))
        if (anyFreeDelivery)    filters.push(new _QuickFilter({id: 'free-delivery', label: 'Despacho gratis', selected: false, action: _Product.filterByFreeDelivery}))
        if (anyPickup)          filters.push(new _QuickFilter({id: 'pickup', label: 'Retiro en tienda', selected: false, action: _Product.filterByPickup}))
        return filters;
    };

    toggleQuickFilter = (quickFilterId) => {
        const {quickFilters} = this.state;
        const matchIndex = quickFilters.findIndex((quickFilter) => quickFilter.id === quickFilterId);
        if (matchIndex >= 0) {
            quickFilters[matchIndex].toggle();
            this.changeState({quickFilters: quickFilters, page: 1}, this.onSelectedQuickFiltersChange);
        }
    };

    onSelectedQuickFiltersChange = () => {
        this.saveSelectedQuickFilters();
        this.saveSelectedPage();
        this.updateResults();
    };

    saveSelectedQuickFilters = () => {
        const {categoryId, searchQuery, quickFilters} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : searchQuery;
        Storage.setQuickFilters({type: type, key: key, quickFilters: quickFilters});
    };

    changeCategoryFilters = (selectedCategories) => {
        this.changeState({selectedCategories: selectedCategories, page: 1}, this.onSelectedCategoryFiltersChange);
    };

    clearCategoryFilters = () => {
        this.changeState({selectedCategories: [], page: 1}, this.onSelectedCategoryFiltersChange);
    };

    onSelectedCategoryFiltersChange = () => {
        this.saveSelectedCategoryFilters();
        this.saveSelectedPage();
        this.updateResults();
    };

    saveSelectedCategoryFilters = () => {
        const {categoryId, selectedCategories} = this.state;
        Storage.setCategoryFilters({category: categoryId, categoryFilters: selectedCategories});
    };

    openFilters = () => {
        this.changeState({showFilters: true});
    };

    closeFilters = () => {
        this.changeState({showFilters: false});
    };

    changeFilters = (filterId, optionId, values) => {
        const newFilters = [...this.state.filters];
        const filter = newFilters.find(filter => filter.id === filterId);
        if (filter) {
            filter.animate = false;
            const option = filter.options.find(option => option.id === optionId);
            switch (filter.type) {
                case 'size':
                    option.setValue(values[0]);
                    break;
                case 'price':
                    option.setStartValue(values[0]);
                    option.setEndValue(values[1]);
                    break;
                default:
                    option.toggle();
                    break;
            }
            this.changeState({filters: newFilters, page: 1}, this.onSelectedFiltersChange);
        }
    };

    removeFilter = (filterId, optionId) => {
        const newFilters = [...this.state.filters];
        const filter = newFilters.find((filter) => filter.id === filterId);
        if (!filter) return;
        const option = filter.options.find((option) => option.id === optionId);
        if (option < 0) return;
        option.deselect();
        this.changeState({filters: newFilters, page: 1}, this.onSelectedFiltersChange);
    };

    clearFilters = () => {
        const newFilters = [...this.state.filters];
        newFilters.forEach((filter) => {
            filter.options.forEach((option) => {
                option.deselect();
            });
        });
        this.changeState({filters: newFilters, page: 1}, this.onSelectedFiltersChange);
    };

    onSelectedFiltersChange = () => {
        this.saveSelectedFilters();
        this.saveSelectedPage();
        this.updateAnsweredQuestions();
        this.updateResults();
    };

    saveSelectedFilters = () => {
        const {categoryId, searchQuery, filters} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : searchQuery;
        const selectedFilters = _Filter.getSelectedFilters(filters);
        const storageFilters = _Filter.toStorage(type, key, selectedFilters);
        Storage.setFilters(storageFilters);
    };

    buildQuestions = () => {
        const {category, filters} = this.state;
        const questions = category.guidedSelling;
        const validQuestions = questions ? questions.filter(q => q.title && q.filterId) : [];
        let questionsWithFilters = [];
        validQuestions.forEach((question) => {
            const filter = filters.find(f => f.id === question.filterId);
            if (filter && filter.options && filter.options.length > 1) {
                const clone = question.clone();
                clone.filter = filter;
                questionsWithFilters.push(clone);
            }
        });
        return questionsWithFilters.sort((a, b) => a.order - b.order);
    };

    onQuestionAnswer = (filterId, optionId, selected) => {
        if (selected) {
            this.changeFilters(filterId, optionId, []);
        } else {
            const newAnsweredQuestions = [...this.state.answeredQuestions];
            const questionIndex = newAnsweredQuestions.indexOf(filterId);
            if (questionIndex < 0) newAnsweredQuestions.push(filterId);
            this.changeState({answeredQuestions: newAnsweredQuestions}, () => {
                this.changeFilters(filterId, optionId, []);
                const {viewRef} = this.props;
                if (viewRef && viewRef.current) viewRef.current.scrollTo({top: 0, behavior: 'instant'});
            });
        }
    };

    onQuestionClose = (filterId) => {
        const newFilters = [...this.state.filters];
        const filter = newFilters.find(filter => filter.id === filterId);
        if (filter) {
            filter.animate = false;
            filter.options.forEach((option) => {
                switch (filter.type) { // MARK: Add price and size filters if they need to be supported in the future.
                    case 'normal':
                        option.deselect();
                        break;
                }
            });
            this.changeState({filters: newFilters, page: 1}, this.onSelectedFiltersChange);
        }
    };

    updateAnsweredQuestions = () => {
        const {filters, answeredQuestions} = this.state;
        const selectedFilters = _Filter.getSelectedFilters(filters);
        const newAnsweredQuestions = [];
        answeredQuestions.forEach((filterId) => {
            const match = selectedFilters.find(filter => filter.id === filterId);
            if (match) newAnsweredQuestions.push(filterId);
        });
        this.changeState({answeredQuestions: newAnsweredQuestions}, () => {
            this.saveAnsweredQuestions();
        });
    };

    saveAnsweredQuestions = () => {
        const {categoryId, searchQuery, answeredQuestions} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : searchQuery;
        Storage.setAnsweredQuestions({type: type, key: key, answeredQuestions: answeredQuestions});
    };

    canFilter = () => {
        const {products, filters} = this.state;
        return products.length > 1 && filters.length > 0;
    };

    canCompare = () => {
        const {products} = this.state;
        return products.length > 1;
    };

    canSort = () => {
        const {products} = this.state;
        return products.length > 1;
    };

    getSelectedFiltersCount = () => {
        let selectedFiltersCount = 0;
        _Filter.getSelectedFilters(this.state.filters).forEach((filter) => {selectedFiltersCount += filter.options.length});
        return selectedFiltersCount;
    };

    clearAllFilters = () => {
        this.clearCategoryFilters();
        this.clearFilters();
    };

    toggleCompareMode = () => {
        const {compareMode} = this.state;
        if (compareMode) {
            this.stopCompareMode();
            this.clearComparisonList();
        } else {
            this.startCompareMode();
        }
    };

    startCompareMode = () => {
        const {category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        Activity.log(metadata, 'compare-mode', 'compare-button', 'start', true, {category_id: category.id, category_name: category.name, search_query: searchQuery || null});
        this.changeState({compareMode: true});
    };

    stopCompareMode = () => {
        const {category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        Activity.log(metadata, 'compare-mode', 'compare-button', 'stop', true, {category_id: category.id, category_name: category.name, search_query: searchQuery || null});
        this.changeState({compareMode: false});
    };

    addProductToComparison = (product) => {
        const {comparisonList, comparisonMaxItems, category, searchQuery} = this.state;
        const exists = comparisonList.findIndex((item) => item.id === product.id) >= 0;
        if (!exists && comparisonList.length < comparisonMaxItems) {
            const metadata = this.getMetadata();
            const productId = product.parent ? product.parent : product.id;
            const variantId = product.parent ? product.id : null;
            Activity.log(metadata, 'compare-mode', product.id, 'add', true, {
                category_id: category ? category.id : null,
                category_name: category ? category.name : null,
                product_id: productId,
                product_name: product.name,
                variant_id: variantId,
                has_3d_model: product.has3dModel || false,
                search_query: searchQuery || null
            });
            comparisonList.push(product);
            this.changeState({comparisonList: comparisonList}, this.saveSelectedComparison);
        }
    };

    removeProductFromComparison = (productId) => {
        const {comparisonList, category, searchQuery} = this.state;
        const matchIndex = comparisonList.findIndex((item) => item.id === productId);
        if (matchIndex >= 0) {
            const product = comparisonList[matchIndex];
            const metadata = this.getMetadata();
            const productId = product.parent ? product.parent : product.id;
            const variantId = product.parent ? product.id : null;
            Activity.log(metadata, 'compare-mode', product.id, 'remove', true, {
                category_id: category ? category.id : null,
                category_name: category ? category.name : null,
                product_id: productId,
                product_name: product.name,
                variant_id: variantId,
                has_3d_model: product.has3dModel || false,
                search_query: searchQuery || null
            });
            comparisonList.splice(matchIndex, 1);
            this.changeState({comparisonList: comparisonList}, this.saveSelectedComparison);
        }
    };

    clearComparisonList = () => {
        this.changeState({comparisonList: []}, this.saveSelectedComparison);
    };

    openComparisonModal = () => {
        const {comparisonList, category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        const metricData = {
            category_id: category ? category.id : null,
            category_name: category ? category.name : null,
            products: comparisonList.map((product) => {
                const productId = product.parent ? product.parent : product.id;
                const variantId = product.parent ? product.id : null;
                return {
                    product_id: productId,
                    product_name: product.name,
                    variant_id: variantId,
                    has_3d_model: product.has3dModel || false
                };
            }),
            search_query: searchQuery || null
        };
        Activity.log(metadata, 'comparison-mode', 'comparison-modal', 'open', true, metricData);
        this.changeState({showComparison: true});
    };

    closeComparisonModal = () => {
        const {comparisonList, category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        const metricData = {
            category_id: category ? category.id : null,
            category_name: category ? category.name : null,
            products: comparisonList.map((product) => {
                const productId = product.parent ? product.parent : product.id;
                const variantId = product.parent ? product.id : null;
                return {
                    product_id: productId,
                    product_name: product.name,
                    variant_id: variantId,
                    has_3d_model: product.has3dModel || false
                };
            }),
            search_query: searchQuery || null
        };
        Activity.log(metadata, 'comparison-mode', 'comparison-modal', 'close', true, metricData);
        this.changeState({showComparison: false});
    };

    onComparisonRedirect = (product) => {
        this.toProductPage(this.state.category, product, -1, 'comparison');
    };

    onComparisonProductChange = (product, index) => {
        const {comparisonList, category, searchQuery} = this.state;
        const oldProduct = comparisonList[index];
        const metadata = this.getMetadata();
        Activity.log(metadata, 'compare-mode', 'comparison-modal', 'change-confirm', true, {
            category_id: category ? category.id : null,
            category_name: category ? category.name : null,
            old_product: oldProduct ? {
                old_product_id: oldProduct.parent ? oldProduct.parent : oldProduct.id,
                old_product_name: oldProduct.name,
                old_variant_id: oldProduct.parent ? oldProduct.id : null,
                old_product_has_3d_model: oldProduct.has3dModel || false
            } : null,
            new_product: {
                new_product_id: product.parent ? product.parent : product.id,
                new_product_name: product.name,
                new_variant_id: product.parent ? product.id : null,
                new_product_has_3d_model: product.has3dModel || false
            },
            searchQuery: searchQuery || null
        });
        if (index >= 0) comparisonList[index] = product;
        else comparisonList.push(product);
        this.changeState({comparisonList: comparisonList}, this.saveSelectedComparison);
    };

    saveSelectedComparison = () => {
        const {categoryId, searchQuery, comparisonList} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : searchQuery;
        Storage.setComparison({type: type, key: key, products: comparisonList.map((product) => product.id)});
    };

    changeSorting = (sortBy) => {
        const {category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        Activity.log(metadata, 'sort-select', sortBy, 'sort', true, {category_id: category.id, category_name: category.name, search_query: searchQuery || null});
        this.changeState({sortBy: sortBy, page: 1}, this.onSelectedSortingChange);
    };

    onSelectedSortingChange = () => {
        this.saveSelectedSorting();
        this.saveSelectedPage();
        this.updateResults();
    };

    saveSelectedSorting = () => {
        const {categoryId, searchQuery, sortBy} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : searchQuery;
        Storage.setSorting({type: type, key: key, sortBy: sortBy});
    };

    changePage = (type, page) => {
        const {category, searchQuery} = this.state;
        const metadata = this.getMetadata();
        const entityId = type ? `${type}-page` : `page-${page}`;
        Activity.log(metadata, 'products-list-paginator', entityId, 'change-page', true, {category_id: category.id, category_name: category.name, search_query: searchQuery || null, target_page: page});
        this.changeState({page: page}, this.onSelectedPageChange);
    };

    onSelectedPageChange = () => {
        this.saveSelectedPage();
        this.updateResults();
    };

    saveSelectedPage = () => {
        const {categoryId} = this.state;
        const type = categoryId ? 'category' : 'search';
        const key = categoryId ? categoryId : this.state.searchQuery;
        Storage.setPage({type: type, key: key, page: this.state.page});
    };

    filteredProducts = (selectedFilters, products) => {
        let response = [];
        const {selectedCategories} = this.state;
        const {style} = this.props;
        const showExternalSale = style && style['global'] && style['global']['filters'] && style['global']['filters']['showExternalSale'] ? style['global']['filters']['showExternalSale'] : false;
        const externalSaleLabel = style && style['global'] && style['global']['filters'] && style['global']['filters']['externalSaleLabel'] ? style['global']['filters']['externalSaleLabel'] : false;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const showAIGeneratedFeatures = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedFeatures'] ? style['global']['features']['showAIGeneratedFeatures'] : false;
        const hasSelectedCategories = selectedCategories && selectedCategories.length > 0;
        const hasSelectedFilters = selectedFilters && selectedFilters.length > 0;
        if (!hasSelectedCategories && !hasSelectedFilters) return products;
        const byCategories = hasSelectedCategories ? _Product.filterByCategories(products, selectedCategories) : [];
        const byFilters = hasSelectedFilters ? _Product.filterByFilters(products, selectedFilters, showExternalSale, externalSaleLabel, clientName, showAIGeneratedFeatures) : [];
        response = hasSelectedCategories ? byCategories : products;
        response = hasSelectedCategories ? (hasSelectedFilters ? response.filter(product => byFilters.includes(product)) : response) : byFilters;
        return response;
    };

    quickFilteredProducts = (products) => {
        const {quickFilters} = this.state;
        let results = products;
        quickFilters.forEach((quickFilter) => {
            if (quickFilter.selected && quickFilter.action) results = quickFilter.action(results);
        });
        return results;
    };

    sortedProducts = (products) => {
        const {sortBy, searchSorting} = this.state;
        switch (sortBy) {
            case '3d':
                return _Product.sortBy3dModel(products);
            case 'featured':
                return _Product.sortByFeatured(products);
            case 'lowest-price':
                return _Product.sortByLowestPrice(products);
            case 'highest-price':
                return _Product.sortByHighestPrice(products);
            case 'relevance':
                return _Product.sortByRelevance(products, searchSorting);
            default:
                return products;
        }
    };

    updateResults = () => {
        const {products, filters} = this.state;
        const valid = _Product.filterValidProducts(products);
        const selectedFilters = _Filter.getSelectedFilters(filters);
        const filtered = this.filteredProducts(selectedFilters, valid);
        const quickFiltered = this.quickFilteredProducts(filtered);
        const sorted = this.sortedProducts(quickFiltered);
        this.changeState({results: sorted});
    };

    onProductClick = (category, product, index) => {
        const {compareMode} = this.state;
        if (compareMode) this.addProductToComparison(product);
        else this.toProductPage(category, product, index, 'catalog');
    };

    toProductPage = (category, product, index, from) => {
        const metadata = this.getMetadata();
        const productId = product.parent ? product.parent : product.id;
        const variantId = product.parent ? product.id : null;
        Activity.log(metadata, 'product', productId, 'click', true, {
            from: from,
            category_id: category ? category.id : null,
            category_name: category ? category.name : null,
            product_id: productId,
            product_name: product.name,
            variant_id: variantId,
            has_3d_model: product.has3dModel || false,
            search_query: this.state.searchQuery || null
        });
        Storage.setLastProduct(productId);
        const url = Navigation.getProductUrl(productId, variantId, metadata.queryId);
        this.props.navigate(url);
    };

    contentWrapperStyle = () => {
        return {
            padding: this.props.inSmallMode ? '40px 0' : '40px 0 40px 90px'
        };
    };

    productsListStyle = (selectedFilters) => {
        const inSmallMode = this.props.inSmallMode;
        const hasChildren = this.state.children.length > 0 && this.state.products.length > 1;
        const hasFilters = selectedFilters.length > 0;
        let heightUnit = 200;
        let multiplier = 0;
        if (!hasChildren && !hasFilters) multiplier = 3;
        if (hasChildren && !hasFilters) multiplier = 6;
        if (!hasChildren && hasFilters) multiplier = 5;
        if (hasChildren && hasFilters) multiplier = 7;
        if (inSmallMode) multiplier += 1;
        return {
            minHeight: `calc(100vh - ${heightUnit * multiplier}px)`
        };
    };

    renderHeader = () => {
        const {style} = this.props;
        const {category, products} = this.state;
        const validProducts = _Product.filterValidProducts(products);
        const clientLogo = style && style['global'] ? style['global']['secondaryClientLogo'] : undefined;
        const titleBarTopSectionBackgroundColor = style && style['category'] ? style['category']['titleBarTopSectionBackgroundColor'] : undefined;
        const titleBarBottomSectionBackgroundColor = style && style['category'] ? style['category']['titleBarBottomSectionBackgroundColor'] : undefined;
        const titleBarBottomSectionLabelColor = style && style['category'] ? style['category']['titleBarBottomSectionLabelColor'] : undefined;
        const titleBarBottomSectionSubtitleColor = style && style['category'] ? style['category']['titleBarBottomSectionSubtitleColor'] : undefined;
        return (
            <Header
                clientLogo={clientLogo}
                category={category}
                productsQuantity={validProducts.length || 0}
                clientLogoBackgroundColor={titleBarTopSectionBackgroundColor}
                categoryBackgroundColor={titleBarBottomSectionBackgroundColor}
                categoryLabelColor={titleBarBottomSectionLabelColor}
                productsLabelColor={titleBarBottomSectionSubtitleColor}
            />
        );
    };

    renderBannerCarousel = () => {
        const {style} = this.props;
        const {banners} = this.state;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        return (
            <BannerCarousel
                key={`banner-carousel-${banners.length}`}
                banners={_Banner.sortBanners(banners)}
                alignItems='flex-start'
                scrollToElement={this.scrollToElement}
                openExternalUrl={this.openBannerExternalUrl}
                customCategoryAction={this.applyBannerFilters}
                dotActiveColor={actionButtonBackgroundColor}
                metadata={this.getMetadata()}
            />
        );
    };

    renderStickyBarsWrapper = (quickFilters, selectedFilters) => {
        return (
            <React.Fragment>
                {this.renderStickyBar(quickFilters, selectedFilters, false, true, true)}
                {this.renderStickyBar(quickFilters, selectedFilters, true, this.state.enableStickyBar, false)}
            </React.Fragment>
        );
    };

    renderStickyBar = (quickFilters, selectedFilters, renderAsSticky, visible, allowAnimation) => {
        const viewport = Viewport.dimensions;
        const showSectionTitle = !!this.state.searchQuery || this.showChildren();
        const showLogo = viewport.width >= 768;
        const clientLogo = this.props.style && this.props.style['global'] ? this.props.style['global']['mainClientLogo'] : undefined;
        return (
            <div className={`category-view-sticky-bar ${renderAsSticky ? 'enabled' : ''}`} style={{display: visible ? 'block' : 'none'}}>
                <div className='category-view-section-title-wrapper' style={{justifyContent: showSectionTitle ? "space-between" : "center"}}>
                    {showSectionTitle && this.renderSectionTitle()}
                    {renderAsSticky && clientLogo && showLogo && (
                        <div className='category-view-section-title-wrapper-sticky-bar-image'>
                            <ImageWrapper image={clientLogo} alt='Logo' display='block' width={170} height='auto' loadDelay={0} />
                        </div>
                    )}
                </div>
                {this.state.compareMode && (
                    <div className='category-view-compare-preview'>
                        {this.renderComparePreview()}
                    </div>
                )}
                {!this.state.compareMode && this.showChildren() && (
                    <div className='category-view-categories-options-container'>
                        {this.renderChildren()}
                    </div>
                )}
                {(this.canFilter() || this.canCompare() || this.canSort()) && (
                    <div className='category-view-actions-container'>
                        {(this.canFilter() || this.canCompare()) && (
                            <div className='category-view-actions-container-first-row'>
                                {this.canFilter() && (
                                    <div className='category-view-filter-button-container'>
                                        {this.renderFiltersButton()}
                                    </div>
                                )}
                                {this.canCompare() && (
                                    <div className='category-view-compare-button-container'>
                                        {this.renderCompareButton()}
                                    </div>
                                )}
                            </div>
                        )}
                        {this.canSort() && (
                            <div className='category-view-actions-container-second-row'>
                                <div className='category-view-sort-select-container'>
                                    {this.renderSortOptions()}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {((quickFilters && quickFilters.length > 0) || (selectedFilters && selectedFilters.length > 0)) && (
                    <div className='category-view-filters-options-container'>
                        {this.renderFilterOptions(quickFilters, selectedFilters, allowAnimation)}
                    </div>
                )}
            </div>
        );
    };

    renderSectionTitle = () => {
        const {compareMode, searchQuery, products} = this.state;
        let title;
        let subtitle;
        if (compareMode) {
            title = 'Selecciona los productos a comparar';
            subtitle = '';
        } else if (searchQuery) {
            title = 'Resultados';
            subtitle = `${products.length} producto(s)`;
        } else {
            title = '¡Selecciona lo que buscas!';
            subtitle = 'Puedes seleccionar múltiples opciones';
        }
        return (
            <div className='category-view-section-title-container'>
                <SectionTitle title={title} subtitle={subtitle}/>
            </div>
        );
    };

    renderComparePreview = () => {
        const {style} = this.props;
        const compareBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const compareBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const compareLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const compareButtonIndicatorBackgroundColor = style && style['category'] && style['category']['compareButtonIndicatorBackgroundColor'] ? style['category']['compareButtonIndicatorBackgroundColor'] : undefined;
        const compareButtonIndicatorLabelColor = style && style['category'] && style['category']['compareButtonIndicatorLabelColor'] ? style['category']['compareButtonIndicatorLabelColor'] : undefined;
        return (
            <ComparePreview
                products={this.state.comparisonList}
                maxItems={this.state.comparisonMaxItems}
                compareBackgroundColor={compareBackgroundColor}
                compareBorderColor={compareBorderColor}
                compareLabelColor={compareLabelColor}
                compareNotificationNumber={this.state.comparisonList ? this.state.comparisonList.length : 0}
                compareNotificationBackgroundColor={compareButtonIndicatorBackgroundColor}
                compareNotificationLabelColor={compareButtonIndicatorLabelColor}
                onRemove={this.removeProductFromComparison}
                onCompare={this.openComparisonModal}
            />
        );
    };

    renderFiltersButton = () => {
        const viewport = Viewport.dimensions;
        const {style} = this.props;
        const backgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const borderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const labelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const filterButtonIcon = style && style['category'] && style['category']['filterButtonIcon'] ? style['category']['filterButtonIcon'] : undefined;
        const filterButtonIndicatorBackgroundColor = style && style['category'] && style['category']['filterButtonIndicatorBackgroundColor'] ? style['category']['filterButtonIndicatorBackgroundColor'] : undefined;
        const filterButtonIndicatorLabelColor = style && style['category'] && style['category']['filterButtonIndicatorBackgroundColor'] ? style['category']['filterButtonIndicatorLabelColor'] : undefined;
        return (
            <Button
                icon={viewport.width < 900 ? undefined : filterButtonIcon}
                label='Filtros'
                labelColor={labelColor}
                backgroundColor={backgroundColor}
                borderColor={borderColor}
                borderRadius={12}
                width='100%'
                notificationNumber={this.getSelectedFiltersCount()}
                notificationBackgroundColor={filterButtonIndicatorBackgroundColor}
                notificationLabelColor={filterButtonIndicatorLabelColor}
                onClick={this.openFilters}
            />
        );
    };

    renderCompareButton = () => {
        const viewport = Viewport.dimensions;
        const {compareMode, comparisonList} = this.state;
        const {style} = this.props;
        const backgroundColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['backgroundColor'] ? style['global']['secondaryActionButton']['backgroundColor'] : undefined;
        const borderColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['borderColor'] ? style['global']['secondaryActionButton']['borderColor'] : undefined;
        const labelColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['labelColor'] ? style['global']['secondaryActionButton']['labelColor'] : undefined;
        const compareButtonIcon = style && style['category'] && style['category']['compareButtonIcon'] ? style['category']['compareButtonIcon'] : undefined;
        const compareButtonIndicatorBackgroundColor = style && style['category'] && style['category']['compareButtonIndicatorBackgroundColor'] ? style['category']['compareButtonIndicatorBackgroundColor'] : undefined;
        const compareButtonIndicatorLabelColor = style && style['category'] && style['category']['compareButtonIndicatorLabelColor'] ? style['category']['compareButtonIndicatorLabelColor'] : undefined;
        let icon, label, _labelColor, _backgroundColor, _borderColor, notificationNumber;
        if (compareMode) {
            icon = closeIcon;
            label= 'Cerrar comparador';
            _labelColor = '#FFFFFF';
            _backgroundColor = '#F00416';
            _borderColor = '#F00416';
            notificationNumber = 0;
        } else {
            icon = compareButtonIcon;
            label= 'Abrir comparador';
            _labelColor = labelColor;
            _backgroundColor = backgroundColor;
            _borderColor = borderColor;
            notificationNumber = comparisonList ? comparisonList.length : 0;
        }
        return (
            <Button
                icon={viewport.width < 900 ? undefined : icon}
                label={label}
                labelColor={_labelColor}
                backgroundColor={_backgroundColor}
                borderColor={_borderColor}
                borderRadius={12}
                width='100%'
                notificationNumber={notificationNumber}
                notificationBackgroundColor={compareButtonIndicatorBackgroundColor}
                notificationLabelColor={compareButtonIndicatorLabelColor}
                boxShadow='none'
                onClick={this.toggleCompareMode}
            />
        );
    };

    renderSortOptions = () => {
        const {style} = this.props;
        const sortSelectionHoverColor = style && style['category'] ? style['category']['sortSelectionHoverColor'] : undefined;
        const sortSelectionAccentColor = style && style['category'] ? style['category']['sortSelectionAccentColor'] : undefined;
        const sortOptionHoverColor = style && style['category'] ? style['category']['sortOptionHoverColor'] : undefined;
        const sortOptionHoverLabelColor = style && style['category'] ? style['category']['sortOptionHoverLabelColor'] : undefined;
        const enabledSortOptions = style && style['category'] ? style['category']['enabledSortOptions'] : undefined;
        let validOptions = [];
        if (!enabledSortOptions) validOptions = this.state.sortOptions;
        else {
            this.state.sortOptions.forEach((option) => {
                if (enabledSortOptions.includes(option.value)) validOptions.push(option);
            });
        }
        return (
            <CustomSelect
                id='category-sort-options'
                label={undefined}
                prefix='Ordenar por'
                placeholder='Ordenamiento'
                value={this.state.sortBy}
                options={validOptions}
                showValueInLabel={false}
                formatLabel={false}
                allowSearch={false}
                height={64}
                selectionHoverColor={sortSelectionHoverColor}
                selectionAccentColor={sortSelectionAccentColor}
                optionHoverColor={sortOptionHoverColor}
                optionHoverLabelColor={sortOptionHoverLabelColor}
                onClick={undefined}
                onChange={this.changeSorting}
            />
        );
    };

    renderChildren = () => {
        const {style} = this.props;
        const {searchQuery, category, selectedCategories} = this.state;
        const children = this.getValidChildren();
        const subcategorySelectionLabelColor = style && style['category'] && style['category']['subcategorySelectionActiveColor'] ? style['category']['subcategorySelectionActiveColor'] : undefined;
        const sorted = children.sort((a, b) => a.order - b.order);
        return (
            <div className='category-view-categories-options-container'>
                <CategoriesOptionsV2 parent={category} searchQuery={searchQuery} categories={sorted} selectedCategories={selectedCategories} activeColor={subcategorySelectionLabelColor} pulseDuration={8} onClick={this.changeCategoryFilters} metadata={this.getMetadata()}/>
            </div>
        );
    };

    renderFilterOptions = (quickFilters, selectedFilters, allowAnimation) => {
        const {style} = this.props;
        const {category, searchQuery} = this.state;
        const quickFilterLabelColor = style && style['category'] ? style['category']['quickFilterLabelColor'] : undefined;
        const quickFilterBackgroundColor = style && style['category'] ? style['category']['quickFilterBackgroundColor'] : undefined;
        const quickFilterCheckboxBackgroundColor = style && style['category'] ? style['category']['quickFilterCheckboxBackgroundColor'] : undefined;
        const filterOptionsLabelColor = style && style['category'] ? style['category']['filterOptionsLabelColor'] : undefined;
        const filterOptionsBackgroundColor = style && style['category'] ? style['category']['filterOptionsBackgroundColor'] : undefined;
        return (
            <FiltersOptions
                category={category}
                searchQuery={searchQuery}
                quickFilters={quickFilters}
                filters={selectedFilters}
                quickFilterLabelColor={quickFilterLabelColor}
                quickFilterBackgroundColor={quickFilterBackgroundColor}
                quickFilterCheckboxBackgroundColor={quickFilterCheckboxBackgroundColor}
                filterLabelColor={filterOptionsLabelColor}
                filterBackgroundColor={filterOptionsBackgroundColor}
                allowAnimation={allowAnimation}
                onToggle={this.toggleQuickFilter}
                onDelete={this.removeFilter}
                metadata={this.getMetadata()}
            />
        );
    };

    renderPaginator = (page, totalPages, margin) => {
        const {style} = this.props;
        const paginatorActiveItemBackgroundColor = style && style['category'] ? style['category']['paginatorActiveItemBackgroundColor'] : undefined;
        const paginatorActiveItemLabelColor = style && style['category'] ? style['category']['paginatorActiveItemLabelColor'] : undefined;
        return (
            <div className='category-view-products-list-paginator' style={{margin: margin}}>
                <Paginator
                    action={this.changePage}
                    currentPage={page}
                    totalPages={totalPages}
                    activeItemBackgroundColor={paginatorActiveItemBackgroundColor}
                    activeItemLabelColor={paginatorActiveItemLabelColor}
                />
            </div>
        );
    };

    renderProducts = (selectedFilters) => {
        const {style} = this.props;
        const {page, perPage, results} = this.state;
        const featuredList = _Product.sortByOrder(results.filter((product) => product.isFeatured));
        const featuredWidthMultiplier = style && style['category'] && style['category']['featuredWidthMultiplier']? style['category']['featuredWidthMultiplier'] : 3;
        const featuredRowSeparation = style && style['category'] && style['category']['featuredRowSeparation'] ? style['category']['featuredRowSeparation'] : 3;
        let slice = results.slice((page - 1) * perPage, page * perPage);
        if (!slice || slice.length === 0) return this.renderNoProducts(selectedFilters);
        const wrapperProperties = HTMLElement.getDisplayProperties(this._categoryViewContentWrapperRef.current);
        const wrapperWidth = wrapperProperties ? wrapperProperties.width : 0;
        const productsPerRow = Math.floor(wrapperWidth / 300); // 300 is the width of a product box, including margins.
        if (productsPerRow <= 0) return;
        const expectedPageFeatured = this.getPageFeaturedProducts(featuredList, slice.length, productsPerRow, featuredWidthMultiplier, featuredRowSeparation, page);
        expectedPageFeatured.forEach((featured) => {
            const inSlice = slice.find((product) => product.id === featured.id);
            if (inSlice) slice = slice.filter((product) => product.id !== featured.id);
        });
        const finalPageFeatured = this.getPageFeaturedProducts(featuredList, slice.length, productsPerRow, featuredWidthMultiplier, featuredRowSeparation, page);
        const featuredLost = expectedPageFeatured.slice(finalPageFeatured.length);
        const rows = [];
        const featuredInRows = [];
        let totalIndex = 0;
        let normalIndex = 0;
        let featuredIndex = 0;
        let rowIndex = 0;
        let productsInRow = 0;
        let canFitMoreProducts = true;
        while (canFitMoreProducts) {
            const isNewRow = !rows[rowIndex];
            if (isNewRow) rows[rowIndex] = [];
            const normalProduct = slice[normalIndex];
            const isFeaturedRow = rowIndex % featuredRowSeparation === 0 && finalPageFeatured.length > 0;
            const featuredProduct = isFeaturedRow && finalPageFeatured && finalPageFeatured.length > 0 ? finalPageFeatured[featuredIndex] : undefined;
            const shouldShowFeatured = isFeaturedRow && !!featuredProduct;
            const featuredPosition = shouldShowFeatured ? (featuredIndex % 2 === 0) ? 'left' : 'right' : undefined;
            const fitsAsLastFeatured = (productsPerRow - productsInRow === featuredWidthMultiplier) || (productsPerRow === 1 && productsInRow === 0);
            const anotherFeaturedInRow = featuredInRows.includes(rowIndex);
            const showFeaturedAtLeft = shouldShowFeatured && !anotherFeaturedInRow && featuredPosition === 'left' && isNewRow;
            const showFeaturedAtRight = shouldShowFeatured && !anotherFeaturedInRow && !showFeaturedAtLeft && featuredPosition === 'right' && fitsAsLastFeatured;
            // Add featured product at the left side.
            if (showFeaturedAtLeft) {
                rows[rowIndex].push(this.renderProduct(totalIndex, featuredProduct, true, featuredWidthMultiplier));
                featuredInRows.push(rowIndex);
                productsInRow += featuredWidthMultiplier;
                totalIndex++;
                featuredIndex++;
            }
            // Add featured product at the right side.
            if (showFeaturedAtRight) {
                rows[rowIndex].push(this.renderProduct(totalIndex, featuredProduct, true, featuredWidthMultiplier));
                featuredInRows.push(rowIndex);
                productsInRow += featuredWidthMultiplier;
                totalIndex++;
                featuredIndex++;
            }
            // Add not featured product.
            if (!showFeaturedAtLeft && !showFeaturedAtRight) {
                if (normalProduct) {
                    rows[rowIndex].push(this.renderProduct(totalIndex, normalProduct, false, undefined));
                    productsInRow++;
                    totalIndex++;
                }
                normalIndex++;
            }
            // Add new row if needed.
            if (productsInRow >= productsPerRow) {
                rowIndex++;
                productsInRow = 0;
            }
            // Check if loop should continue.
            canFitMoreProducts = normalIndex < perPage;
        }
        // If any featured products are lost when removing duplicates, add it to the last row.
        if (featuredLost && featuredLost.length > 0) {
            featuredLost.forEach((featuredProduct) => {
                const newRow = productsInRow + featuredWidthMultiplier > productsPerRow;
                if (newRow) {
                    rowIndex++;
                    productsInRow = 0;
                    rows[rowIndex] = [];
                }
                rows[rowIndex].push(this.renderProduct(totalIndex, featuredProduct, true, featuredWidthMultiplier));
                productsInRow += featuredWidthMultiplier;
                totalIndex++;
            });
        }
        return this.renderProductsList(rows, selectedFilters);
    };

    // It is normal that this function calculates more space than what is actually shown, because is not counting based on the available products, 
    // instead is using the theoretical used space that N rows should cover, but it doesn't matter because if the last row has 1 product or its full, 
    // the row will be shown regardless, the quantity of rows that we will calculate later will be the same.
    getPageFeaturedProducts = (featuredList, productsQuantity, productsPerRow, featuredWidthMultiplier, featuredRowSeparation, currentPage) => {
        let rows = 0;
        let usedSpace = 0;
        while (usedSpace < productsQuantity) {
            if (rows % featuredRowSeparation === 0) {
                usedSpace += productsPerRow - featuredWidthMultiplier + 1;
                if (usedSpace < 1) usedSpace = 1; // Ensure at least one space is used.
            } else usedSpace += productsPerRow;
            rows++;
        }
        const featuredProductsPerPage = rows > 0 && featuredRowSeparation > 0 ? Math.ceil(rows / featuredRowSeparation) : 0;
        const pageFeatured = featuredList.slice((currentPage - 1) * featuredProductsPerPage, currentPage * featuredProductsPerPage);
        return pageFeatured;
    };

    renderProduct = (index, product, isFeatured, featuredWidthMultiplier) => {
        const {style} = this.props;
        const {category, page, perPage, lastProduct} = this.state;
        const clientName = style && style['global'] && style['global']['clientName'] ? style['global']['clientName'] : undefined;
        const productBoxDesign = style && style['category'] && style['category']['productBoxDesign'] ? style['category']['productBoxDesign'] : undefined;
        const _3dIcon = style && style['category'] && style['category']['3dIcon'] ? style['category']['3dIcon'] : undefined;
        const taxMultiplier = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxMultiplier'] ? style['global']['checkout']['taxMultiplier'] : 1;
        const taxLabel = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxLabel'] ? style['global']['checkout']['taxLabel'] : 'DESC';
        const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
        const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
        const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
        const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
        const offerBackgroundColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['backgroundColor'] ? style['global']['offers']['backgroundColor'] : undefined;
        const offerLabelColor = style && style['global'] && style['global']['offers'] && style['global']['offers']['labelColor'] ? style['global']['offers']['labelColor'] : undefined;
        const offerLabel = style && style['global'] && style['global']['offers'] && style['global']['offers']['label'] ? style['global']['offers']['label'] : undefined;
        const offerIcon = style && style['global'] && style['global']['offers'] && style['global']['offers']['icon'] ? style['global']['offers']['icon'] : undefined;
        const freeDeliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['icon'] ? style['global']['tags']['freeDelivery']['icon'] : undefined;
        const freeDeliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['labelColor'] ? style['global']['tags']['freeDelivery']['labelColor'] : undefined;
        const freeDeliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['freeDelivery'] && style['global']['tags']['freeDelivery']['backgroundColor'] ? style['global']['tags']['freeDelivery']['backgroundColor'] : undefined;
        const deliveryIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['icon'] ? style['global']['tags']['delivery']['icon'] : undefined;
        const deliveryLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['labelColor'] ? style['global']['tags']['delivery']['labelColor'] : undefined;
        const deliveryBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['delivery'] && style['global']['tags']['delivery']['backgroundColor'] ? style['global']['tags']['delivery']['backgroundColor'] : undefined;
        const pickupIcon = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['icon'] ? style['global']['tags']['pickup']['icon'] : undefined;
        const pickupLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['labelColor'] ? style['global']['tags']['pickup']['labelColor'] : undefined;
        const pickupBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['pickup'] && style['global']['tags']['pickup']['backgroundColor'] ? style['global']['tags']['pickup']['backgroundColor'] : undefined;
        const infoTagBorderColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['borderColor'] ? style['global']['tags']['infoTag']['borderColor'] : undefined;
        const infoTagBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['backgroundColor'] ? style['global']['tags']['infoTag']['backgroundColor'] : undefined;
        const infoTagLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['infoTag'] && style['global']['tags']['infoTag']['labelColor'] ? style['global']['tags']['infoTag']['labelColor'] : undefined;
        const otherTagsBackgroundColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['others'] && style['global']['tags']['others']['backgroundColor'] ? style['global']['tags']['others']['backgroundColor'] : undefined;
        const otherTagsLabelColor = style && style['global'] && style['global']['tags'] && style['global']['tags']['others'] && style['global']['tags']['others']['labelColor'] ? style['global']['tags']['others']['labelColor'] : undefined;
        const sellerLabelColor = style && style['global'] && style['global']['seller'] && style['global']['seller']['labelColor'] ? style['global']['seller']['labelColor'] : undefined;
        const mainSellerIcon = style && style['global'] && style['global']['seller'] && style['global']['seller']['mainIcon'] ? style['global']['seller']['mainIcon'] : undefined;
        const taxDisclaimerBackgroundColor = style && style['category'] && style['category']['taxDisclaimerBackgroundColor'] ? style['category']['taxDisclaimerBackgroundColor'] : undefined;
        const taxDisclaimerLabelColor = style && style['category'] && style['category']['taxDisclaimerLabelColor'] ? style['category']['taxDisclaimerLabelColor'] : undefined;
        const featuredDefaultIcon = style && style['category'] && style['category']['featuredDefaultIcon'] ? style['category']['featuredDefaultIcon'] : undefined;
        const featuredDefaultLabel = style && style['category'] && style['category']['featuredDefaultLabel'] ? style['category']['featuredDefaultLabel'] : undefined;
        const featuredBackgroundColor = style && style['category'] && style['category']['featuredBackgroundColor'] ? style['category']['featuredBackgroundColor'] : undefined;
        const featuredLabelColor = style && style['category'] && style['category']['featuredLabelColor'] ? style['category']['featuredLabelColor'] : undefined;
        const featuredDefaultMediaWidthPercentage = style && style['category'] && style['category']['featuredDefaultMediaWidthPercentage'] ? style['category']['featuredDefaultMediaWidthPercentage'] : undefined;
        const showSeller = style && style['category'] ? style['category']['showSeller'] : false;
        const showDelivery = style && style['category'] ? style['category']['showDelivery'] : false;
        const showRating = style && style['category'] ? style['category']['showRating'] : false;
        const showTags = style && style['category'] ? style['category']['showTags'] : false;
        const showInfoTagOnImage = style && style['category'] ? style['category']['showInfoTagOnImage'] : false;
        const infoTagLabel = style && style['category'] ? style['category']['infoTagLabel'] : undefined;
        const infoTagProperty = style && style['category'] ? style['category']['infoTagProperty'] : undefined;
        const inComparisonList = this.state.compareMode && !!this.state.comparisonList.find((item) => item.id === product.id);
        return (
            <ProductBox
                key={`category-product-${product.id}`}
                idPrefix='category-product'
                viewRef={this.props.viewRef}
                index={((page - 1) * perPage) + index}
                category={category}
                product={product}
                showSku={true}
                showIcons={true}
                active={lastProduct === product.id}
                clientName={clientName}
                design={productBoxDesign}
                _3dIcon={_3dIcon}
                isFeatured={isFeatured}
                shouldDrawGallery={true}
                shouldDraw3D={this.isFeaturedProductInViewport(product.id)}
                taxMultiplier={taxMultiplier}
                taxLabel={taxLabel}
                discountBackgroundColor={discountBackgroundColor}
                discountLabelColor={discountLabelColor}
                exclusivePriceLabelColor={exclusivePriceLabelColor}
                exclusivePriceIcon={exclusivePriceIcon}
                offerBackgroundColor={offerBackgroundColor}
                offerLabelColor={offerLabelColor}
                offerLabel={offerLabel}
                offerIcon={offerIcon}
                freeDeliveryIcon={freeDeliveryIcon}
                freeDeliveryLabelColor={freeDeliveryLabelColor}
                freeDeliveryBackgroundColor={freeDeliveryBackgroundColor}
                deliveryIcon={deliveryIcon}
                deliveryLabelColor={deliveryLabelColor}
                deliveryBackgroundColor={deliveryBackgroundColor}
                pickupIcon={pickupIcon}
                pickupLabelColor={pickupLabelColor}
                pickupBackgroundColor={pickupBackgroundColor}
                infoTagBorderColor={infoTagBorderColor}
                infoTagBackgroundColor={infoTagBackgroundColor}
                infoTagLabelColor={infoTagLabelColor}
                otherTagsBackgroundColor={otherTagsBackgroundColor}
                otherTagsLabelColor={otherTagsLabelColor}
                sellerLabelColor={sellerLabelColor}
                mainSellerIcon={mainSellerIcon}
                taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                featuredDefaultIcon={featuredDefaultIcon}
                featuredDefaultLabel={featuredDefaultLabel}
                featuredDefaultMediaWidthPercentage={featuredDefaultMediaWidthPercentage}
                featuredWidthMultiplier={featuredWidthMultiplier}
                featuredBackgroundColor={featuredBackgroundColor}
                featuredLabelColor={featuredLabelColor}
                showPulseEffect={this.state.compareMode && this.state.comparisonList.length === 0}
                pulseEffectColor={offerBackgroundColor}
                pulseEffectIterations={8}
                selected={inComparisonList}
                selectedBorderColor={inComparisonList ? offerBackgroundColor : undefined}
                showSeller={showSeller}
                showDelivery={showDelivery}
                showRating={showRating}
                showTags={showTags}
                showInfoTagOnImage={showInfoTagOnImage}
                infoTagLabel={infoTagLabel}
                infoTagProperty={infoTagProperty}
                visible={true}
                disabled={false}
                onClick={this.onProductClick}
            />
        );
    };

    renderProductsList = (rows, selectedFilters) => {
        const {style} = this.props;
        const {searchQuery, page, perPage, results, selectedCategories, answeredQuestions} = this.state;
        const questions = this.buildQuestions();
        const remainingQuestions = questions.filter(q => !answeredQuestions.includes(q.filterId));
        const latestQuestion = answeredQuestions && answeredQuestions.length > 0 ? questions.find(q => q.filterId === answeredQuestions[answeredQuestions.length - 1]) : null;
        const anyQuestions = remainingQuestions && remainingQuestions.length > 0;
        const inSearchMode = !!searchQuery;
        const questionRowSeparation = style && style['category'] && style['category']['questionRowSeparation'] ? style['category']['questionRowSeparation'] : 5;
        let questionIndex = 0;
        let content = [];
        rows.forEach((row, rowIndex) => {
            const question = questionIndex < remainingQuestions.length ? remainingQuestions[questionIndex] : null;
            const inQuestionRow = rowIndex > 0 && rowIndex % questionRowSeparation === 0;
            if (!inSearchMode && anyQuestions && question && inQuestionRow) {
                content.push(this.renderQuestion(question, false));
                questionIndex++;
            }
            content.push(
                <div key={`products-list-row-${rowIndex}`} className='category-view-products-list-row'>{row}</div>
            );
        });
        const hasCategoryFilters = selectedCategories.length > 0;
        const hasNormalFilters = selectedFilters.length > 0;
        const totalPages = Math.ceil(results.length / perPage);
        return (
            <React.Fragment>
                {latestQuestion && <div className='category-view-latest-question'>{this.renderQuestion(latestQuestion, true)}</div>}
                {(hasCategoryFilters || hasNormalFilters) && <div className='category-view-filter-results'>{results.length} resultado(s) encontrado(s)</div>}
                {totalPages > 1 && this.renderPaginator(page, totalPages, '20px 0')}
                <div className='category-view-products-list' style={this.productsListStyle(selectedFilters)}>{content}</div>
                {totalPages > 1 && this.renderPaginator(page, totalPages, '30px 0 0 0')}
            </React.Fragment>
        );
    };

    renderNoProducts = (selectedFilters) => {
        const {inSmallMode} = this.props;
        const {selectedCategories} = this.state;
        const hasCategoryFilters = selectedCategories.length > 0;
        const hasNormalFilters = selectedFilters.length > 0;
        let message;
        let actionLabel;
        let action;
        if (hasCategoryFilters || hasNormalFilters) {
            message = 'No se han encontrado productos';
            actionLabel = 'Limpiar';
            action = this.clearAllFilters;
        } else {
            message = 'No se han encontrado productos';
            actionLabel = 'Volver';
            action = this.back;
        }
        return (
            <div className='category-view-no-data' style={{marginRight: inSmallMode ? 0 : 90}}>
                {this.renderError(message, actionLabel, action)}
            </div>
        );
    };

    renderQuestion = (question, featured) => {
        const {style} = this.props;
        const {category} = this.state;
        const questionBackgroundColor = style && style['category'] && style['category']['questionBackgroundColor'] ? style['category']['questionBackgroundColor'] : undefined;
        const questionFilterBackgroundColor = style && style['category'] && style['category']['questionFilterBackgroundColor'] ? style['category']['questionFilterBackgroundColor'] : undefined;
        const questionFilterLabelColor = style && style['category'] && style['category']['questionFilterLabelColor'] ? style['category']['questionFilterLabelColor'] : undefined;
        const questionTitleLabelColor = style && style['category'] && style['category']['questionTitleLabelColor'] ? style['category']['questionTitleLabelColor'] : undefined;
        const questionDescriptionLabelColor = style && style['category'] && style['category']['questionDescriptionLabelColor'] ? style['category']['questionDescriptionLabelColor'] : undefined;
        const questionCloseButtonBackgroundColor = style && style['category'] && style['category']['questionCloseButtonBackgroundColor'] ? style['category']['questionCloseButtonBackgroundColor'] : undefined;
        const questionCloseButtonLabelColor = style && style['category'] && style['category']['questionCloseButtonLabelColor'] ? style['category']['questionCloseButtonLabelColor'] : undefined;
        const checkboxBackgroundColor = style && style['global'] && style['global']['filters'] && style['global']['filters']['checkboxBackgroundColor'] ? style['global']['filters']['checkboxBackgroundColor'] : undefined;
        return (
            <Question
                key={`question-${question.filterId}`}
                category={category}
                title={question.title}
                description={question.description}
                filter={question.filter}
                featured={featured}
                backgroundColor={questionBackgroundColor}
                filterBackgroundColor={questionFilterBackgroundColor}
                filterLabelColor={questionFilterLabelColor}
                titleLabelColor={questionTitleLabelColor}
                descriptionLabelColor={questionDescriptionLabelColor}
                closeButtonBackgroundColor={questionCloseButtonBackgroundColor}
                closeButtonLabelColor={questionCloseButtonLabelColor}
                checkboxBackgroundColor={checkboxBackgroundColor}
                onAnswerClick={this.onQuestionAnswer}
                onClose={this.onQuestionClose}
                metadata={this.getMetadata()}
            />
        );
    };

    renderFilters = () => {
        const {style} = this.props;
        const filtersBackgroundColor = style && style['global'] && style['global']['filters'] && style['global']['filters']['backgroundColor'] ? style['global']['filters']['backgroundColor'] : undefined;
        const filtersLabelColor = style && style['global'] && style['global']['filters'] && style['global']['filters']['labelColor'] ? style['global']['filters']['labelColor'] : undefined;
        const filtersCheckboxBackgroundColor = style && style['global'] && style['global']['filters'] && style['global']['filters']['checkboxBackgroundColor'] ? style['global']['filters']['checkboxBackgroundColor'] : undefined;
        const featuredButtonStyle = style && style['global'] && style['global']['filters'] && style['global']['filters']['featured'] ? style['global']['filters']['featured'] : {};
        const brandsButtonStyle = style && style['global'] && style['global']['filters'] && style['global']['filters']['brands'] ? style['global']['filters']['brands'] : {};
        const sizeButtonStyle = style && style['global'] && style['global']['filters'] && style['global']['filters']['size'] ? style['global']['filters']['size'] : {};
        const priceButtonStyle = style && style['global'] && style['global']['filters'] && style['global']['filters']['price'] ? style['global']['filters']['price'] : {};
        const othersButtonStyle = style && style['global'] && style['global']['filters'] && style['global']['filters']['others'] ? style['global']['filters']['others'] : {};
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <FiltersModal
                category={this.state.category}
                searchQuery={this.state.searchQuery}
                filters={this.state.filters}
                onChange={this.changeFilters}
                onClear={this.clearFilters}
                onConfirm={() => {}}
                onClose={this.closeFilters}
                backgroundColor={filtersBackgroundColor}
                labelColor={filtersLabelColor}
                checkboxBackgroundColor={filtersCheckboxBackgroundColor}
                featuredButtonStyle={featuredButtonStyle}
                brandsButtonStyle={brandsButtonStyle}
                sizeButtonStyle={sizeButtonStyle}
                priceButtonStyle={priceButtonStyle}
                othersButtonStyle={othersButtonStyle}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
                actionButtonLabelColor={actionButtonLabelColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                metadata={this.getMetadata()}
            />
        );
    };

    renderComparison = () => {
        const {style} = this.props;
        const taxMultiplier = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxMultiplier'] ? style['global']['checkout']['taxMultiplier'] : 1;
        const taxLabel = style && style['global'] && style['global']['checkout'] && style['global']['checkout']['taxLabel'] ? style['global']['checkout']['taxLabel'] : 'DESC';
        const taxDisclaimerBackgroundColor = style && style['category'] && style['category']['taxDisclaimerBackgroundColor'] ? style['category']['taxDisclaimerBackgroundColor'] : undefined;
        const taxDisclaimerLabelColor = style && style['category'] && style['category']['taxDisclaimerLabelColor'] ? style['category']['taxDisclaimerLabelColor'] : undefined;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        const secondaryActionButtonBackgroundColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['backgroundColor'] ? style['global']['secondaryActionButton']['backgroundColor'] : undefined;
        const secondaryActionButtonBorderColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['borderColor'] ? style['global']['secondaryActionButton']['borderColor'] : undefined;
        const secondaryActionButtonLabelColor = style && style['global'] && style['global']['secondaryActionButton'] && style['global']['secondaryActionButton']['labelColor'] ? style['global']['secondaryActionButton']['labelColor'] : undefined;


        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;

        const compareGoToProductButtonIcon = style && style['category'] && style['category']['compareGoToProductButtonIcon'] ? style['category']['compareGoToProductButtonIcon'] : undefined;
        const compareAddProductButtonIcon = style && style['category'] && style['category']['compareAddProductButtonIcon'] ? style['category']['compareAddProductButtonIcon'] : undefined;
        const compareHighlightColor = style && style['category'] && style['category']['compareHighlightColor'] ? style['category']['compareHighlightColor'] : undefined;
        const compareChangerSelectionColor = style && style['category'] && style['category']['compareChangerSelectionColor'] ? style['category']['compareChangerSelectionColor'] : undefined;
        const compareChangerPreviousSelectionColor = style && style['category'] && style['category']['compareChangerPreviousSelectionColor'] ? style['category']['compareChangerPreviousSelectionColor'] : undefined;
        const discountBackgroundColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountBackgroundColor'] ? style['global']['prices']['discountBackgroundColor'] : undefined;
        const discountLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['discountLabelColor'] ? style['global']['prices']['discountLabelColor'] : undefined;
        const exclusivePriceLabelColor = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceLabelColor'] ? style['global']['prices']['exclusivePriceLabelColor'] : undefined;
        const exclusivePriceIcon = style && style['global'] && style['global']['prices'] && style['global']['prices']['exclusivePriceIcon'] ? style['global']['prices']['exclusivePriceIcon'] : undefined;
        const paginatorActiveItemBackgroundColor = style && style['category'] ? style['category']['paginatorActiveItemBackgroundColor'] : undefined;
        const paginatorActiveItemLabelColor = style && style['category'] ? style['category']['paginatorActiveItemLabelColor'] : undefined;
        const showAIGeneratedFeatures = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedFeatures'] ? style['global']['features']['showAIGeneratedFeatures'] : false;
        const showAIGeneratedTag = style && style['global'] && style['global']['features'] && style['global']['features']['showAIGeneratedTag'] ? style['global']['features']['showAIGeneratedTag'] : false;
        const AIGeneratedTagLabel = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagLabel'] ? style['global']['features']['AIGeneratedTagLabel'] : undefined;
        const AIGeneratedTagBackgroundColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagBackgroundColor'] ? style['global']['features']['AIGeneratedTagBackgroundColor'] : undefined;
        const AIGeneratedTagLabelColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagLabelColor'] ? style['global']['features']['AIGeneratedTagLabelColor'] : undefined;
        const AIGeneratedTagBorderColor = style && style['global'] && style['global']['features'] && style['global']['features']['AIGeneratedTagBorderColor'] ? style['global']['features']['AIGeneratedTagBorderColor'] : undefined;
        return (
            <ComparisonModal
                client={this.props.client}
                catalog={this.props.catalog}
                category={this.state.category}
                products={this.state.products}
                searchQuery={this.state.searchQuery}
                comparisonList={this.state.comparisonList}
                comparisonMaxItems={this.state.comparisonMaxItems}
                taxMultiplier={taxMultiplier}
                taxLabel={taxLabel}
                taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
                actionButtonLabelColor={actionButtonLabelColor}
                secondaryActionButtonBackgroundColor={secondaryActionButtonBackgroundColor}
                secondaryActionButtonBorderColor={secondaryActionButtonBorderColor}
                secondaryActionButtonLabelColor={secondaryActionButtonLabelColor}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                compareGoToProductButtonIcon={compareGoToProductButtonIcon}
                compareAddProductButtonIcon={compareAddProductButtonIcon}
                compareHighlightColor={compareHighlightColor}
                compareChangerSelectionColor={compareChangerSelectionColor}
                compareChangerPreviousSelectionColor={compareChangerPreviousSelectionColor}
                discountBackgroundColor={discountBackgroundColor}
                discountLabelColor={discountLabelColor}
                exclusivePriceLabelColor={exclusivePriceLabelColor}
                exclusivePriceIcon={exclusivePriceIcon}
                paginatorActiveItemBackgroundColor={paginatorActiveItemBackgroundColor}
                paginatorActiveItemLabelColor={paginatorActiveItemLabelColor}
                showAIGeneratedFeatures={showAIGeneratedFeatures}
                showAIGeneratedTag={showAIGeneratedTag}
                AIGeneratedTagLabel={AIGeneratedTagLabel}
                AIGeneratedTagBackgroundColor={AIGeneratedTagBackgroundColor}
                AIGeneratedTagLabelColor={AIGeneratedTagLabelColor}
                AIGeneratedTagBorderColor={AIGeneratedTagBorderColor}
                onClick={this.onComparisonRedirect}
                onChange={this.onComparisonProductChange}
                onRemove={this.removeProductFromComparison}
                onClose={this.closeComparisonModal}
                getMetadata={this.getMetadata}
            />
        );
    };

    renderBannerExternalUrl = () => {
        const {style} = this.props;
        const qrScanImage = style && style['categories'] && style['categories']['bannerExternalUrlQrScanImage'] ? style['categories']['bannerExternalUrlQrScanImage'] : undefined;
        const cancelButtonBackgroundColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['backgroundColor'] ? style['global']['cancelButton']['backgroundColor'] : undefined;
        const cancelButtonBorderColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['borderColor'] ? style['global']['cancelButton']['borderColor'] : undefined;
        const cancelButtonLabelColor = style && style['global'] && style['global']['cancelButton'] && style['global']['cancelButton']['labelColor'] ? style['global']['cancelButton']['labelColor'] : undefined;
        return (
            <BannerExternalUrlModal
                externalUrl={this.state.bannerModalExternalUrl}
                qrScanImage={qrScanImage}
                cancelButtonBackgroundColor={cancelButtonBackgroundColor}
                cancelButtonBorderColor={cancelButtonBorderColor}
                cancelButtonLabelColor={cancelButtonLabelColor}
                onClose={this.closeBannerExternalUrl}
                metadata={this.props.getMetadata()}
            />
        );
    };

    renderError = (message, actionLabel, action) => {
        const {style} = this.props;
        const actionButtonBackgroundColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['backgroundColor'] ? style['global']['actionButton']['backgroundColor'] : undefined;
        const actionButtonBorderColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['borderColor'] ? style['global']['actionButton']['borderColor'] : undefined;
        const actionButtonLabelColor = style && style['global'] && style['global']['actionButton'] && style['global']['actionButton']['labelColor'] ? style['global']['actionButton']['labelColor'] : undefined;
        return (
            <DataError
                message={message}
                actionLabel={actionLabel}
                action={action}
                actionButtonLabelColor={actionButtonLabelColor}
                actionButtonBackgroundColor={actionButtonBackgroundColor}
                actionButtonBorderColor={actionButtonBorderColor}
            />
        );
    };

    render() {
        const selectedFilters = _Filter.getSelectedFilters(this.state.filters);
        return (
            <div className='category-view'>
                {this.loadingData() && (
                    <div className='category-view-loader'>
                        <div className='category-view-loader-wrapper'>
                            <DataLoader message='Cargando productos disponibles...'/>
                        </div>
                    </div>
                )}
                {!this.loadingData() && !this.dataLoaded() && (
                    <React.Fragment>
                        {this.state.notFound ? (
                            <NotFound message={undefined} actionLabel={this.state.errorActionLabel} action={this.state.errorAction} style={this.props.style}/>
                        ) : (
                            <div className='category-view-error'>
                                <div className='category-view-error-wrapper'>
                                    {this.renderError(this.state.errorMessage, this.state.errorActionLabel, this.state.errorAction)}
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}
                {!this.loadingData() && this.dataLoaded() && (
                    <React.Fragment>
                        {!this.hasBanners() && <div className='category-view-header-container'>{this.renderHeader()}</div>}
                        {this.hasBanners() && <div className='category-view-carousel-container'>{this.renderBannerCarousel()}</div>}
                        <div ref={this._categoryViewContentWrapperRef} className='category-view-content-wrapper' style={this.contentWrapperStyle()}>
                            {this.renderStickyBarsWrapper(this.state.quickFilters, selectedFilters)}
                            <div className='category-view-products-list-container'>
                                {this.renderProducts(selectedFilters)}
                            </div>
                        </div>
                        {this.state.showFilters && !this.props.showInactivityModal && this.renderFilters()}
                        {this.state.showComparison && !this.props.showInactivityModal && this.renderComparison()}
                        {this.state.showBannerExternalUrlModal && this.renderBannerExternalUrl()}
                    </React.Fragment>
                )}
            </div>
        );
    };
}

export default withRouter(Category);

Category.propTypes = {
    params: PropTypes.object,
    viewRef: PropTypes.object,
    customHomeCategoryId: PropTypes.string,
    client: PropTypes.string,
    instance: PropTypes.object,
    catalog: PropTypes.object,
    store: PropTypes.object,
    session: PropTypes.object,
    style: PropTypes.object,
    accessibilityMode: PropTypes.bool,
    getMetadata: PropTypes.func,
    inSmallMode: PropTypes.bool,
    showInactivityModal: PropTypes.bool
};